import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = [
    "fleetLogBookForm",
    "logBookField",
    "select",
    "signatureCanvas",
    "signatureInput",
  ]
  connect() {
    if (this.hasSelectTarget) {
      this.toggleFleetLogBookFields()
    }
    if (this.hasSignatureCanvasTarget) {
      this.initializeSignaturePad()
    }
  }

  showModal() {
    this.toggleModalsVisibility(false)
    this.resetFleetCodeInputs()
    this.clearErrors()
  }

  submitForm(event) {
    event.preventDefault()

    const form = event.target
    const formData = new FormData(form)

    this.disableSubmitButton(form, true)

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: { Accept: "text/html" },
    })
      .then((response) => {
        if (response.ok) {
          return response.text()
        } else if (response.status === 404) {
          throw new Error("Mit diesem Code wurde keine Auto gefunden.")
        } else {
          throw new Error("Serverfehler. Bitte versuchen Sie es später noch einmal.")
        }
      })
      .then((html) => {
        this.updatePartial(html)
        this.hideModal()
        form.reset()
      })
      .catch((error) => {
        const errorElements = document.querySelectorAll(".errorElement")
        this.displayError(errorElements, error.message)
      })
      .finally(() => {
        this.disableSubmitButton(form, false)
      })
  }

  hideModal() {
    this.toggleModalsVisibility(true)
    this.resetFleetCodeInputs()
    this.clearErrors()
  }

  // Helper functions
  toggleModalsVisibility(hidden) {
    const modals = document.querySelectorAll(".fleetModal")
    modals.forEach((modal) => modal.classList.toggle("hidden", hidden))
  }

  resetFleetCodeInputs() {
    const fleetCodeInputs = document.querySelectorAll(".fleetCodeInput")
    fleetCodeInputs.forEach((input) => (input.value = ""))
  }

  clearErrors() {
    const errorElements = document.querySelectorAll(".errorElement")
    errorElements.forEach((error) => {
      error.textContent = ""
      error.classList.add("hidden")
    })
  }

  updatePartial(html) {
    const partialContainer = document.getElementById("partialContainer")
    const partialHeader = document.getElementById("partialHeader")
    const otherFieldsElements = document.querySelectorAll("#otherFields")

    if (partialContainer) {
      partialContainer.innerHTML = html
      partialContainer.classList.remove("hidden")
      partialHeader.classList.remove("hidden")
      otherFieldsElements.forEach((field) => field.classList.add("hidden"))
    } else {
      console.error("Error: partialContainer with id 'partialContainer' is not found in the DOM.")
    }
  }

  displayError(errorElements, message) {
    errorElements.forEach((error) => {
      error.textContent = message
      error.classList.remove("hidden")
    })
  }

  disableSubmitButton(form, disabled) {
    form.querySelector('input[type="submit"]').disabled = disabled
  }

  submitFleetLogBookForm(event) {
    event.preventDefault()
    const form = event.target
    const formData = new FormData(form)

    this.disableSubmitButton(form, true)

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          window.location.href = data.redirect_url
        } else {
          const errorContainer = document.querySelectorAll("#logBookErrorElement")
          this.displayError(errorContainer, data.errors.shift())
        }
      })
      .catch((_error) => {
        const errorContainer = document.querySelectorAll("#logbookErrorElement")
        this.displayError(errorContainer, "An unexpected error occurred")
      })
      .finally(() => {
        this.disableSubmitButton(form, false)
      })
  }

  toggleFleetLogBookFields() {
    const hasValue = this.selectTarget.value !== ""
    this.logBookFieldTargets.forEach((field) => {
      field.style.display = hasValue ? "block" : "none"
    })
    if (hasValue) {
      this.initializeSignaturePad()
    }
  }

  initializeSignaturePad() {
    if (this.hasSignatureCanvasTarget) {
      const canvas = this.signatureCanvasTarget

      if (this.signaturePad) {
        this.signaturePad.off()
      }

      canvas.width = canvas.offsetWidth
      canvas.height = canvas.offsetHeight

      this.signaturePad = new SignaturePad(canvas, {
        penColor: "rgb(66, 133, 244)",
      })

      this.signaturePad.addEventListener("endStroke", () => {
        if (this.hasSignatureInputTarget) {
          this.signatureInputTarget.value = this.signaturePad.toDataURL()
        }
      })
    } else {
      console.error("Signature canvas target not found")
    }
  }
}
